import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.1
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ForWhomSection() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-white)'
  }} data-id="element-39">
      <motion.div className="max-w-[800px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-40">
        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-4 text-center" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-41">
          Para quién es (y para quién no)
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-12 text-center max-w-[600px] mx-auto" style={{
        color: 'var(--color-slate)',
        opacity: 0.7
      }} data-id="element-42">
          Queremos que estés segura antes de comprar.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-43">
          {/* Es para ti si */}
          <motion.div variants={childVariants} className="rounded-2xl p-7 md:p-8" style={{
          backgroundColor: 'var(--color-cream)'
        }} data-id="element-44">
            <h3 className="text-xl md:text-2xl mb-6" style={{
            color: 'var(--color-slate)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-45">
              Es para ti si…
            </h3>

            <div className="space-y-4" data-id="element-46">
              <div className="flex items-start gap-3" data-id="element-47">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-sage)'
              }} data-id="element-48">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-49" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)'
              }} data-id="element-50">
                  Quieres verte más firme y sentirte más fuerte
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-51">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-sage)'
              }} data-id="element-52">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-53" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)'
              }} data-id="element-54">
                  Te frustran los planes largos
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-55">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-sage)'
              }} data-id="element-56">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-57" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)'
              }} data-id="element-58">
                  Quieres entrenar en casa
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-59">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-sage)'
              }} data-id="element-60">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-61" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)'
              }} data-id="element-62">
                  Necesitas un sistema para retomar después de fallar
                </p>
              </div>
            </div>
          </motion.div>

          {/* No es para ti si */}
          <motion.div variants={childVariants} className="rounded-2xl p-7 md:p-8" style={{
          backgroundColor: 'var(--color-cream)'
        }} data-id="element-63">
            <h3 className="text-xl md:text-2xl mb-6" style={{
            color: 'var(--color-slate)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-64">
              No es para ti si…
            </h3>

            <div className="space-y-4" data-id="element-65">
              <div className="flex items-start gap-3" data-id="element-66">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-blush)'
              }} data-id="element-67">
                  <XIcon className="w-3.5 h-3.5" style={{
                  color: 'var(--color-slate)',
                  opacity: 0.5
                }} data-id="element-68" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)',
                opacity: 0.8
              }} data-id="element-69">
                  Buscas gym avanzado/culturismo
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-70">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-blush)'
              }} data-id="element-71">
                  <XIcon className="w-3.5 h-3.5" style={{
                  color: 'var(--color-slate)',
                  opacity: 0.5
                }} data-id="element-72" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)',
                opacity: 0.8
              }} data-id="element-73">
                  Quieres rutinas largas intensas todos los días
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-74">
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'var(--color-blush)'
              }} data-id="element-75">
                  <XIcon className="w-3.5 h-3.5" style={{
                  color: 'var(--color-slate)',
                  opacity: 0.5
                }} data-id="element-76" />
                </div>
                <p className="text-base md:text-lg" style={{
                color: 'var(--color-slate)',
                opacity: 0.8
              }} data-id="element-77">
                  Necesitas rehabilitación médica individual (lesiones graves o
                  postparto complejo sin aprobación médica)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}